(() => {
  const mq = window.matchMedia("(min-width: 992px)");

  function qs(sel, root = document) {
    return root.querySelector(sel);
  }

  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  onReady(() => {
    const media =
      qs(".xo-product-info-media-carousel.xo-product-info-media-carousel--grid") ||
      qs(".xo-product-info-media-carousel");

    if (!media) return;

    // HARD STOP marker (you add this in Liquid)
    const endMarker = qs("#zeal-product-end");

    // Wrap media in a pin container if not already
    let pin = media.closest(".zeal-media-pin");
    if (!pin) {
      pin = document.createElement("div");
      pin.className = "zeal-media-pin";
      media.parentNode.insertBefore(pin, media);
      pin.appendChild(media);
    }

    // Spacer prevents layout jump when pin becomes fixed
    let spacer = qs(".zeal-media-spacer", pin.parentNode);
    if (!spacer || spacer.nextElementSibling !== pin) {
      spacer = document.createElement("div");
      spacer.className = "zeal-media-spacer";
      spacer.style.width = "100%";
      spacer.style.display = "none";
      pin.parentNode.insertBefore(spacer, pin);
    }

    let headerOffset = 80; // MUST match CSS top
    let startY = Infinity;
    let stopY = -Infinity;
    let pinWidth = 0;
    let pinTopPageOriginal = null;

    // Lock the LEFT position in PAGE coordinates (not viewport)
    let lockedPageLeft = null;

    function compute() {
      if (!mq.matches) return;

      // Reset while measuring
      pin.classList.remove("is-fixed", "is-stopped");
      spacer.style.display = "none";
      pin.style.width = "";
      pin.style.left = "";

      lockedPageLeft = null;

      spacer.style.height = pin.offsetHeight + "px";

      const scrollY = window.scrollY || window.pageYOffset;

      const pinRect = pin.getBoundingClientRect();
      pinWidth = pinRect.width;

      if (pinTopPageOriginal === null) {
        pinTopPageOriginal = scrollY + pinRect.top;
      }

      startY = pinTopPageOriginal - headerOffset;

      // Stop exactly at the marker if present
      if (endMarker) {
        const endRect = endMarker.getBoundingClientRect();
        const endTopPage = scrollY + endRect.top;
        stopY = endTopPage - headerOffset - pin.offsetHeight;
      } else {
        // Fallback: stop at bottom of the nearest product-information block
        const boundary =
          qs(".product-information") ||
          qs(".product-information__box") ||
          media.closest(".xo-product-info") ||
          media.closest(".product") ||
          media.closest("main") ||
          document.body;

        const bRect = boundary.getBoundingClientRect();
        const bBottomPage = scrollY + bRect.bottom;
        stopY = bBottomPage - headerOffset - pin.offsetHeight;
      }

      // If still too short, disable pin
      if (stopY <= startY + 20) {
        startY = Infinity;
        stopY = -Infinity;
      }
    }

    function getPageLeftFromSpacer() {
      const scrollX = window.scrollX || window.pageXOffset;
      const r = spacer.getBoundingClientRect();
      return scrollX + r.left; // PAGE coordinate
    }

    function setState(state) {
      pin.classList.remove("is-fixed", "is-stopped");

      if (state === "fixed") {
        pin.classList.add("is-fixed");
        spacer.style.display = "block";

        // Lock left once (page-left)
        if (lockedPageLeft === null) {
          lockedPageLeft = getPageLeftFromSpacer();
        }

        // Fixed uses VIEWPORT left
        const scrollX = window.scrollX || window.pageXOffset;
        const viewportLeft = lockedPageLeft - scrollX;

        pin.style.width = pinWidth + "px";
        pin.style.left = viewportLeft + "px";
      }

      else if (state === "stopped") {
        pin.classList.add("is-stopped");
        spacer.style.display = "block";

        if (lockedPageLeft === null) {
          lockedPageLeft = getPageLeftFromSpacer();
        }

        // Absolute uses OFFSET PARENT coordinates
        const scrollX = window.scrollX || window.pageXOffset;
        const offsetParent = pin.offsetParent || pin.parentElement;
        const opRect = offsetParent.getBoundingClientRect();
        const opPageLeft = scrollX + opRect.left;

        pin.style.width = pinWidth + "px";
        pin.style.left = (lockedPageLeft - opPageLeft) + "px";
      }

      else {
        spacer.style.display = "none";
        pin.style.width = "";
        pin.style.left = "";
        lockedPageLeft = null;
      }
    }

    let ticking = false;
    function update() {
      ticking = false;

      if (!mq.matches) {
        setState("normal");
        return;
      }

      const y = window.scrollY || window.pageYOffset;

      if (y >= startY && y < stopY) setState("fixed");
      else if (y >= stopY) setState("stopped");
      else setState("normal");
    }

    function requestTick() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener("load", () => {
      compute();
      update();
    });

    window.addEventListener("resize", () => {
      pinTopPageOriginal = null;
      compute();
      requestTick();
    });

    window.addEventListener("scroll", requestTick, { passive: true });

    compute();
    update();
  });
})();
